import "../../assets/scss/components/sections/resumes/resume.scss";
// import "../../assets/scss/base/gray_background.scss";
import { Container } from "react-bootstrap";
import BackBtn from "../../components/templates/back";

import { useEffect, useState } from "react";

import Resume from "./resume";
import Navbar from "../../components/templates/navbar";
import Header from "./header";
import Interview from "./interview/interview";
import ToggleButtonCustom from "../../components/templates/toggleBtn";
import { download_file, getResumeDetails } from "./helper";
import { useNavigate, useParams } from "react-router-dom";
import {
  getLocalStorage,
  isTokenPresent,
  removeLocalStorage,
  setLocalStorage,
} from "../../utils/userHelper";
import { downloadButtonClicked } from "../../utils/commonHelper";
// import InterviewComponent from "./helpers/interviewCompnent";

const ResumeDetails = () => {
  useEffect(() => {
    // Set background when component mounts
    document.body.style.backgroundColor = "#F6F7F9";

    // Optional: reset it when the component unmounts
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  const { id } = useParams();
  const navigate = useNavigate();
  const [activePlan, setActiveBtn] = useState("Resume");
  const [isLoading, setIsLoading] = useState(true);
  const [isInsightsVisible, setIsInsightsVisible] = useState(false);
  const [resumeDetails, setResumeDetails] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const handleToggle = () => {
    setIsInsightsVisible((prevState) => !prevState);
  };

  // 👇 Timeout to stop loading after 5 seconds
  useEffect(() => {
    let isMounted = true;
    const fetchResumeDetails = async () => {
      if (!id) return;
      console.log(id);

      try {
        setIsLoading(true);
        const details = await getResumeDetails(id);
        if (isMounted && Object.values(details).length > 0) {
          setResumeDetails(details);
          setIsLoading(false);
          checkExistingFileToDownload();
        }
      } catch (error) {
        console.error("Error fetching resume details:", error);
      }
    };

    fetchResumeDetails();

    return () => {
      isMounted = false;
    };
  }, [id]);

  const handleButtonClick = (plan) => {
    setActiveBtn(plan);
  };
  const renderContent = () => {
    if (activePlan === "Resume") {
      return (
        <Resume
          isLoading={isLoading}
          isInsightsVisible={isInsightsVisible}
          resumeData={[
            resumeDetails?.final_resume_dict,
            resumeDetails?.metadata,
            resumeDetails?._id,
          ]}
          downloadButtonClicked={() =>
            downloadButtonClicked(
              resumeDetails?.resume_file_url,
              resumeDetails?.metadata?.slug,
              id,
              setIsDownloading,
              navigate
            )
          }
          isDownloading={isDownloading}
        />
      );
    } else if (activePlan === "Interview Questions") {
      return (
        <Interview
          isInsightsVisible={isInsightsVisible}
          resumeId={id}
          skillsData={resumeDetails?.metadata}
        />
      );
    }
  };

  const checkExistingFileToDownload = () => {
    const existResumeUrl = getLocalStorage("downloadResumeUrl");
    const existResumeSlug = getLocalStorage("downloadResumeSlug");
    const existResumeId = getLocalStorage("downloadResumeId");
    if (existResumeUrl) {
      downloadButtonClicked(
        existResumeUrl,
        existResumeSlug,
        existResumeId,
        setIsDownloading,
        navigate
      );
    }
  };
  return (
    <div className="resume-generating-section">
      <Navbar />
      <Container>
        <div className="resume-generating">
          <div className="content">
            <div>
              <BackBtn backButtonPress={() => navigate('/library')} />

              <Header isLoading={isLoading} resume={resumeDetails?.metadata} />
            </div>
            <div className="switch-buttons text-center mb-4">
              {["Resume", "Interview Questions"].map((plan) => (
                <button
                  key={plan}
                  className={`filter-btn ${
                    activePlan === plan ? "active" : ""
                  }`}
                  onClick={() => handleButtonClick(plan)}
                >
                  {plan}
                </button>
              ))}
            </div>

            <h6 className="toggle-btn mb-3">
              Hide Insights
              <ToggleButtonCustom
                isToggled={isInsightsVisible}
                onToggle={handleToggle}
              />
            </h6>
          </div>
          {renderContent()}
        </div>
      </Container>
    </div>
  );
};

export default ResumeDetails;
